import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-datasource';
import { APChangelog } from '../builders/ap_changelog_builder';
import { IAPChangelogDatasource } from '../datasources/ap_changelog_datasource';
import { APChangelogServant } from '../servants/ap_changelog_servant';

interface IAPChangelogQueryResult {
  changelog: APChangelog[];
}

export class APChangelogQuery implements IQuery {
  private __result: IAPChangelogQueryResult;
  constructor(private ngAPChangelogDatasource: IAPChangelogDatasource) {
    ORMMediator.registerQuery(this, ngAPChangelogDatasource);
  }
  run(): this {
    const changelog = this.ngAPChangelogDatasource.read();
    const changelogWithDisplayText = _4.map(changelog, (changeLogItem: APChangelog) => ({
      ...APChangelogServant.getChangelogDisplayText(changeLogItem),
      latestComment: _4.last(_4.sortBy(changeLogItem.comments, (comment) => moment(comment['updated_ts'] as string)))
    }));

    const orderedChangelog = _4.orderBy(changelogWithDisplayText, 'committed_ts', 'desc');

    this.__result = {
      changelog: orderedChangelog
    };

    return this;
  }

  get result(): IAPChangelogQueryResult {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPChangelogQuery', APChangelogQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/changelog/queries/ap_changelog_query.ts